export class ApAnonymizerService {
    public static readonly amountListRange = [
        -990000000, -1000000, -750000, -600000, -500000, -400000, -350000, -300000, -250000, -200000, -150000, -100000, -75000, -50000,
        -40000, -30000, -20000, -15000, -10000, -5000, -4000, -3000, -2000, -1000, -750, -500, -250, 0, 250, 500, 750, 1000, 2000, 3000,
        4000, 5000, 10000, 15000, 20000, 30000, 40000, 50000, 75000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 500000, 600000,
        750000, 1000000, 990000000
    ];
    public static anonymizeAmount(amount: string, range: number[] = ApAnonymizerService.amountListRange): string {
        const parsedValue = parseInt(amount.replace(/,/g, ''), 10);
        let beginRange = null;
        let endRange = null;

        for (let i = 0; i < range.length; i++) {
            if (parsedValue >= range[i]) {
                beginRange = range[i];
                endRange = range[i + 1] || null;
            }
        }

        return beginRange !== null && endRange !== null ? `[${beginRange}]-[${endRange}]` : 'out of range';
    }

    public static anonymizeDate(date: Date): string {
        return `${date.getMonth() + 1}-${date.getFullYear()}`;
    }

    public static anonymizeBirthDate(value: Date): string {
        const today = new Date();
        const monthDiff = today.getMonth() - value.getMonth();
        let age = today.getFullYear() - value.getFullYear();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < value.getDate())) {
            age--;
        }

        return `${age}`;
    }

    public static anonymizeZipCode(zipCode: string): string {
        return zipCode.slice(0, 4);
    }

    public static anonymizePercentage(value: number): string {
        let beginRange = null;
        let endRange = null;
        const parsedInt = Math.floor(value);
        if (value > 0 && value < 100) {
            beginRange = parsedInt + 0.5 <= value ? parsedInt + 0.5 : parsedInt;
            endRange = beginRange + 0.5;
        }
        return beginRange !== null && endRange !== null ? `[${beginRange}]-[${endRange}]` : 'out of range';
    }
}
